<div
    class="tw-relative tw-bg-no-repeat tw-bg-gradient-to-b tw-from-[#e6e6e6] tw-to-[#FFFFFF] sm:tw-bg-gradient-to-b sm:tw-from-[#e6e6e6] sm:tw-to-[#FFFFFF] xl:tw-bg-[url('assets/images/Bg.png')] tw-bg-[length:100%] tw-min-h-[100vh]"
>
    <header class="">
        <div
            class="tw-relative tw-flex tw-justify-center tw-pt-20 tw-min-h-[5rem] tw-w-full tw-px-[5vw] md:tw-px-[4vw]"
        >
            <div class="tw-flex tw-justify-center tw-items-center">
                <img
                    src="/assets/images/logo/header_desktop.webp"
                    alt="logo"
                    class="tw-cursor-pointer tw-h-auto tw-w-[50%] lg:tw-w-[40%] sm:tw-w-[50%]"
                />
            </div>
        </div>
    </header>
    <div
        class="tw-flex tw-justify-center tw-gap-[6vw] md:tw-mt-[3rem] tw-mx-[2rem]"
    >
        <div class="tw-mt-20">
            <div class="tw-flex tw-items-center tw-gap-[2rem]">
                <div
                    class="tw-min-h-[4rem] tw-min-w-[4rem] tw-rounded-full tw-bg-accent-light tw-flex tw-items-center tw-justify-center"
                >
                    <mat-icon class="check-icon">check</mat-icon>
                </div>
                <div class="">
                    <div class="tw-text-[40px]">
                        {{ "COMMON.SUCCESS" | translate }}
                    </div>
                    <div class="tw-text-gray-400">
                        {{
                            "RESET_PASSWORD.SUCCESS_RESET_PASSWORD_DESCRIPTION"
                                | translate
                        }}
                    </div>
                </div>
            </div>

            <button
                class="tw-mt-10 tw-rounded-2xl tw-text-white tw-font-semibold tw-bg-[#e3d8c9] tw-bg-primary-orange-light tw-py-[1rem] tw-w-[120%] access-btn"
                (click)="goToSignIn()"
            >
                {{ "COMMON.LOGIN" | translate }}
            </button>
        </div>
    </div>
</div>
